module.exports = __webpack_public_path__ + "static/media/king.92e7c21b.svg";